import { MutationTree } from "vuex";
import { IDemoState } from "@/store/modules/demo/types";

import {
  IContentSection,
  IPassage,
  IQuestion,
} from "@/store/modules/content/types";

type DemoMutationsTree = MutationTree<IDemoState>;

export const mutations: DemoMutationsTree = {
  setSections(state: IDemoState, sections: IContentSection[]) {
    state.sections = sections;
  },

  setSection(state: IDemoState, section: IContentSection) {
    state.section = section;
  },

  setQuestions(state: IDemoState, questions: IQuestion[]) {
    state.questions = questions;
  },

  setPassages(state: IDemoState, passages: IPassage[]) {
    state.passages = passages;
  },

  setCompletedSections(state: IDemoState, sections: {}) {
    state.completedSections = { ...state.completedSections, ...sections };
  },
};
